export default __webpack_public_path__ + "static/media/sarh.c543c8fb.png";